<div class="collaboration">
  <app-post-wall *ngIf="post" [post]="post" [taskId]="taskId" [org]="org" [isDraftTaxPage]="false" [companyId]="channelId" [channelType]="channelType"
             [isDocView]="isDocView" [pageType]="pageType" [displayType]="displayType"
             (onRemovePost)="deletePost($event)" [postStatus] = postStatus [taskSinglePost]="taskSinglePost"></app-post-wall>
</div>
